import React, { FC, Fragment } from 'react'
import {
    StyledTheWestLivePlayerWrapper,
    StyledTheWestLivePlayerEqualiser,
    StyledTheWestLivePlayerVolume,
    StyledTheWestLivePlayerButton,
    StyledTheWestLivePlayerVolumeGroup,
    StyledTheWestLivePlayerBigButton,
    StyledTheWestLiveOnAirNotice,
} from './TheWestLivePlayerSkin.styled'
import { TheWestLivePlayerSkinProps } from '../TheWestLivePlayer'
import { breakpoints } from '../../../../__styling/settings/breakpoints'

export const TheWestLivePlayerSkin: FC<TheWestLivePlayerSkinProps> = ({
    state,
    volume,
    onAir,
    onControlClick,
    onVolumeChange,
}) => {
    const numEqualiserBars =
        typeof window !== 'undefined' &&
        window.matchMedia(`(min-width: ${breakpoints.sm}px)`).matches
            ? 9
            : 3

    return (
        <StyledTheWestLivePlayerWrapper>
            <StyledTheWestLivePlayerButton
                state={state}
                onClick={onControlClick}
            />

            {onAir && state === 'stopped' && <StyledTheWestLiveOnAirNotice />}

            {state === 'playing' && (
                <Fragment>
                    <StyledTheWestLivePlayerEqualiser
                        widthInBars={numEqualiserBars}
                        volume={onAir ? volume : 0}
                    />
                    <StyledTheWestLivePlayerVolume
                        onChange={onVolumeChange}
                        value={volume}
                    />
                </Fragment>
            )}
        </StyledTheWestLivePlayerWrapper>
    )
}

export const LivePlayerChunky: FC<TheWestLivePlayerSkinProps> = ({
    state,
    volume,
    onAir,
    onControlClick,
    onVolumeChange,
}) => {
    return (
        <StyledTheWestLivePlayerWrapper>
            <StyledTheWestLivePlayerBigButton
                state={state}
                onClick={onControlClick}
                bigButton={true}
            />

            {onAir && state === 'stopped' && (
                <StyledTheWestLiveOnAirNotice showOnAirIconOnMobile />
            )}

            {state === 'playing' && (
                <StyledTheWestLivePlayerVolumeGroup>
                    <StyledTheWestLivePlayerEqualiser
                        widthInBars={18}
                        volume={onAir ? volume : 0}
                    />
                    <StyledTheWestLivePlayerVolume
                        onChange={onVolumeChange}
                        value={volume}
                    />
                </StyledTheWestLivePlayerVolumeGroup>
            )}
        </StyledTheWestLivePlayerWrapper>
    )
}

export const LivePlayerButtonOnly: FC<TheWestLivePlayerSkinProps> = ({
    state,
    onControlClick,
}) => {
    return (
        <StyledTheWestLivePlayerWrapper>
            <StyledTheWestLivePlayerBigButton
                state={state}
                onClick={onControlClick}
            />
        </StyledTheWestLivePlayerWrapper>
    )
}
